module.exports = __webpack_public_path__ + "static/CBET Course Catalog_Volume XVIII_7.20.20-f8cf455d985f81a4f649ef85a369d185.pdf";